import script from "./ConfirmType.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConfirmType.vue?vue&type=script&lang=ts&setup=true"

import "./ConfirmType.vue?vue&type=style&index=0&id=3763d330&lang=scss&scoped=true"
import "./ConfirmType.vue?vue&type=style&index=1&id=3763d330&lang=scss"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3763d330"]])

export default __exports__